import { useInfiniteQuery } from '@tanstack/react-query';

import { APIClientBase } from ':cloud/state/Api';
import { PaymasterLogItem } from ':cloud/types/ts_types';

import { QueryKey } from '../types';

type GetPaymasterLogsProps = {
  organizationId?: string;
  projectId?: string;
  starttime: string;
  endtime: string;
  cursor?: string;
  service: string;
  network: 'base' | 'base-sepolia';
};

async function getPaymasterLogs({
  organizationId = '',
  projectId = '',
  starttime,
  endtime,
  cursor,
  network,
  service,
}: GetPaymasterLogsProps): Promise<PaymasterLogItem[]> {
  const basePath = '/rpc/api/requestlogs';
  const { data } = await APIClientBase.get<PaymasterLogItem[]>(
    `${basePath}?organizationid=${organizationId}&projectid=${projectId}&starttime=${starttime}&endtime=${endtime}&limit=50&cursor=${cursor}&network=${network}&service=${service}`,
  );
  return data || [];
}

export function useGetPaymasterLogs({
  organizationId = '',
  projectId = '',
  starttime,
  endtime,
  cursor,
  network,
  service,
}: GetPaymasterLogsProps) {
  const { data, isFetching, fetchNextPage, hasNextPage, isFetchingNextPage, status } =
    useInfiniteQuery({
      queryKey: [
        QueryKey.paymasterLogs,
        service,
        organizationId,
        projectId,
        starttime,
        endtime,
        cursor,
        network,
      ],
      queryFn: async ({ pageParam = '' }) =>
        getPaymasterLogs({
          organizationId,
          projectId,
          starttime,
          endtime,
          cursor: pageParam,
          network,
          service,
        }),
      getNextPageParam: (lastPage: PaymasterLogItem[]) => {
        return lastPage?.length === 50 ? lastPage[49].id : undefined;
      },
      initialData: {
        pages: [],
        pageParams: [],
      },
    });
  return {
    data,
    isLoading: isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
  };
}
